import { useSearchParams } from 'react-router-dom';

export const useUrlParam = (name: string): [() => string | null, (value: string) => void, () => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const set = (value: string) => {
    searchParams.set(name, value);
    setSearchParams(searchParams);
  };

  const get = () => {
    return searchParams.get(name);
  };

  const clear = () => {
    searchParams.delete(name);
    setSearchParams(searchParams);
  };

  return [get, set, clear];
};
